angular.module('wbDashboard').controller('PlanningMortgageNewControllerAurea', ['$scope', '$timeout', '$uibModal', '$q', '$window', 'PlanningService', 'ThinkingService', 'CommonConstant', 'Message', 'Request', 'Track', function ($scope, $timeout, $uibModal, $q, $window, PlanningService, ThinkingService, CommonConstant, Message, Request, Track) {

    $scope.mortgage = {
        home_value: null,
        interest_rate: null,
        monthly_payment: null,
        percent_of_monthly_income: null,
        timer: null,
    };

    $scope.pageData = {
        sending: false,
        updatingSavings: false,
        thinking: false,
        modalInstance: null,
    };
    $scope.forms = {};

    $scope.options = {
    };

    $scope.recommendationSlug = $scope.$stateParams.recommendationSlug ? $scope.$stateParams.recommendationSlug : PlanningService.partnerInfo.mortgageNew.slug;


    $scope.showLoading = function() {
        $scope.pageData.thinking = true;
        ThinkingService.open($scope, "mortgage", {thinking:"Calculating Your Mortgage Payments", complete:"Complete!"});
    };

    $scope.mortgageModal = function() {
        $scope.year = new Date().getFullYear();

        $scope.pageData.modalInstance = $uibModal.open({
            templateUrl: 'app/themes/aurea/segments/planning/planning.partner.mortgage.disclosure.tpl.html',
            scope: $scope,
            size: 'md',
            windowClass:'mortgage-disclosure-modal'
        });
        $scope.pageData.modalInstance.result.catch(angular.noop);
    };

    $scope.submitToPartner = function() {

        Track.send("Send to Partner", "planning", {partner: $scope.mortgage.referral_partner});

        $scope.pageData.sending = true;
        PlanningService.completeRecommendation($scope.recommendationSlug).finally(function() {
            // angular.element("form[name='forms.mortgage']").submit();
            $window.location.href = $scope.mortgage.referral_url;
        });
    };

    $scope.complete = function() {
        $scope.pageData.sending = true;
        PlanningService.completeRecommendation($scope.recommendationSlug).then(function() {
            return PlanningService.retrieveRecommendations(true);
        }).finally(function() {
            $scope.$state.go('base.planning');
        });
    };

    $scope.goNextPage = function() {
        switch ($scope.$stateParams.page) {
            case 'adjust':
                if ($scope.mortgage.found_referral) {
                    if ($scope.mortgage.referral_partner === 'axos') {
                        $scope.$state.go('.', {page: 'introducing-axos'});
                    } else {
                        $scope.$state.go('.',{page:'introducing-no-one'});
                    }
                } else {
                    $scope.$state.go('.',{page:'introducing-no-one'});
                }
                break;
        }

    };

    init();

    function init() {

        $scope.$watch('mortgage.home_value', function (homeValue) {
            if (homeValue) {
                $scope.pageData.updatingSavings = true;

                $timeout.cancel($scope.mortgage.timer);
                $scope.mortgage.timer = $timeout(function () {
                    //need to create manual debounce
                    updateSavings(homeValue);
                }, 750);
            }
        });

        $scope.showLoading();

        $q.all([getRecommend(), updateSavings()]).then(function() {
            $scope.pageData.thinking = false;

            $scope.$state.go(".", {page: "adjust"}, {location: "replace"});

        }).then(function() {
            ThinkingService.close(false, 'mortgage');
        });


    }

    function updateSavings(homeValue) {
        $scope.pageData.sending = true;
        $scope.pageData.updatingSavings = true;
        if (!updateSavings.count) {
            updateSavings.count = 0;
        }
        updateSavings.count++;

        return Request.make('mortgage_orig_savings', {homeValue: homeValue}).then(function(response) {
            /**
             * @param {Object} data
             * @param {int} data.est_monthly_payments
             * @param {int} data.percentage_of_income
             * @param {int} data.interest_rate
             * @param {int} data.home_value
             */
            var data = response.data;
            //convert all values to numerics
            data.down_payment *= 1;
            data.home_value *= 1;
            data.interest_rate *= 1;
            data.monthly_payment *= 1;
            data.percent_of_monthly_income *= 1;

            if (!$scope.mortgage.home_value || $scope.mortgage.home_value === data.home_value) {
                //in case it was changed since requested
                angular.extend($scope.mortgage, data);
            }
        }).catch(function() {
        }).finally(function() {
            updateSavings.count--;
            if (!updateSavings.count) {
                $scope.pageData.sending = false;
                $scope.pageData.updatingSavings = false;
            }
        });

    }

    function getRecommend() {
        $scope.pageData.sending = true;

        return Request.make('mortgage_orig_recommend').then(function(response) {
            var data = response.data;

            angular.extend($scope.mortgage, data);

        }).catch(function() {
        }).finally(function() {
            $scope.pageData.sending = false;
        });
    }

    var transitionDeregisterHook;
    transitionDeregisterHook = $scope.$transitions.onBefore({ to: 'base.planning.mortgage' }, function(trans) {
        if (trans.params('to').page === "submit") {
            //get token?
        }
    });
    $scope.$on('$destroy', function() {
        transitionDeregisterHook();
    });

}]);
